// extracted by mini-css-extract-plugin
export var caption = "NewProductCard-mps-module--caption--0a320";
export var landscape = "NewProductCard-mps-module--landscape--47d67";
export var root = "NewProductCard-mps-module--root--74794";